<div *ngIf='items && items.length' class='UploadConfirmationDialog'>
  <app-table [columns]='tableColumns' [dataSourceParams]='dataSourceParams' [dataSource]='dataSource'></app-table>
</div>
